import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 15 18" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.5 18V0l14 9-14 9z" /></svg>;